import { useState, useEffect } from 'react';
import { officialService, Official } from '../services/officials';

export const useOfficials = () => {
  const [officials, setOfficials] = useState<Official[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOfficials = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await officialService.getOfficials();
        setOfficials(data);
      } catch (err) {
        setError('Error fetching officials');
        console.error('Error in useOfficials:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOfficials();
  }, []);

  return { officials, loading, error };
};
